<script setup lang='ts'>
import { useI18n } from 'vue-i18n';

import EcoFriendlyIcon from '@/components/labels/EcoFriendlyIcon.vue';

const props = defineProps<{
  activityName: string;
}>();

const { t } = useI18n();
</script>

<template>
  <section class="eco-friendly-box normal_spacing">
    <div class="eco-friendly-header">
      <span class="icon">
        <EcoFriendlyIcon icon-color="var(--yb-color-ecofriendly)" />
      </span>
      <h3>{{ t('content.eco_friendly.title') }}</h3>
    </div>
    <p>
      {{ t('content.eco_friendly.description', { activityName: props.activityName }) }}
    </p>
    <p class="small_spacing">
      {{ t('content.eco_friendly.detail') }}
    </p>
  </section>
</template>

<style scoped>
.small_spacing {
  margin-bottom: var(--yb-spacing-sm);
}

.normal_spacing {
  margin-bottom: var(--yb-radius-base);
}

.eco-friendly-box {
  display: flex;
  flex-direction: column;
  background-color: #effbf4;
  padding: var(--yb-spacing-base);
  border-radius: var(--yb-card-radius);
  gap: var(--yb-spacing-sm);

  .eco-friendly-header {
    display: flex;
    align-items: center;
    font-weight: bold;
    color: var(--yb-color-ecofriendly);
  }

  .eco-friendly-header h3 {
    color: #19cc67;
  }

  .eco-friendly-header .icon {
    display: flex;
    margin-right: var(--yb-spacing-xs);
    svg path {
      fill: var(--yb-color-ecofriendly);
    }
  }
}
</style>
